import PropTypes from "prop-types"
export default function ExternalLinks({ children, onLinkClick }) {
  const handleClick = (event) => {
    const link = event.target.closest("a")
    if (!link) {
      return null
    }

    event.preventDefault()

    if (typeof onLinkClick === "function") {
      onLinkClick(link.href, link.textContent)
    }

    window.open(link.href, "_blank")
  }

  return (
    <div onClick={handleClick}>
      {children}
    </div>
  )
}

ExternalLinks.propTypes = {
  children: PropTypes.node.isRequired,
  onLinkClick: PropTypes.func,
}
